module.exports = __webpack_public_path__ + "img/2.f681c424.jpg";